import { EMPTY_ARRAY } from "@/constants/stable-empty";
import { KubernetesPodData } from "@/gen_src/proto/chalk/kubernetes/v1/pods_pb";
import { getNodesAndPodsUI } from "@/gen_src/proto/chalk/server/v1/billing-BillingService_connectquery";
import { GetNodesAndPodsUIResponse } from "@/gen_src/proto/chalk/server/v1/billing_pb";
import { useIdle } from "@/utils/hooks/use-idle";
import { useIsServerlessEnvironment } from "@/utils/hooks/use-is-serverless-environment";
import { getBadPods } from "@/utils/kube";
import { ConnectError } from "@connectrpc/connect";
import { useQuery } from "@connectrpc/connect-query";
import { UseQueryResult } from "@tanstack/react-query";
import { useSession } from "next-auth/react";
import { useMemo } from "react";

const POLL_INTERVAL = 15_000;

export function useKubePodsCrashing(environmentId: string | undefined): {
  badPods: Array<[KubernetesPodData, string]>;
  underlying: UseQueryResult<GetNodesAndPodsUIResponse, ConnectError>;
} {
  const session = useSession();
  const idle = useIdle();
  const { isServerless, loading: environmentLoading } = useIsServerlessEnvironment();
  const canViewPods = !environmentLoading && !isServerless;
  const podsQuery = useQuery(
    getNodesAndPodsUI,
    {
      environmentId,
      podLabelSelector: `component in (engine, engine-grpc, streaming-worker),chalk.ai/environment=${environmentId}`,
    },
    {
      enabled: canViewPods && environmentId != null && session.status === "authenticated",
      refetchInterval: idle ? undefined : POLL_INTERVAL,
    },
  );

  const pods = podsQuery.data?.pods;
  // const pods = require("../../../components/test-page/mocks/kube-pods-mock.json").pods;

  const badPods = useMemo(() => {
    if (!canViewPods || pods == null) return EMPTY_ARRAY as Array<[KubernetesPodData, string]>;
    return getBadPods(pods);
  }, [canViewPods, pods]);

  return { badPods, underlying: podsQuery };
}
